export const BIG_WIDTH = 1150
